import React from "react";
import Layout from "../../../components/layout/layout.js";
import { StatsView } from "../../../components/stats/stats-view.js";

export default function StatsViewPage({ component, ...rest }) {
  return <Layout Component={StatsView} {...rest} controlsDisabled />;
}




